/** Assume Entity / log-in-as session helpers ("oldUser" holds the account we came from). */

const OLD_USER_KEY = "oldUser";

/** Fired when an admin read is refused while an impersonation session is active. */
export const IMPERSONATION_FORBIDDEN_EVENT = "impersonation-forbidden";

const parseStoredUser = (stored: string): any | null => {
  try {
    return JSON.parse(stored);
  } catch (error) {
    console.error("Error parsing oldUser:", error);
    return null;
  }
};

export const isImpersonationSession = (): boolean => !!localStorage.getItem(OLD_USER_KEY);

/** The account that started the impersonation, or null when not impersonating. */
export const getImpersonationOrigin = (): any | null => {
  const stored = localStorage.getItem(OLD_USER_KEY);
  return stored ? parseStoredUser(stored) : null;
};

/**
 * Put the original account back in place and end the impersonation session.
 * Returns the restored account so the caller can refresh the auth header and navigate.
 */
export const restoreImpersonationOrigin = (): any | null => {
  const stored = localStorage.getItem(OLD_USER_KEY);
  const origin = stored ? parseStoredUser(stored) : null;
  if (!stored || !origin) return null;

  localStorage.setItem("user", stored);
  localStorage.removeItem(OLD_USER_KEY);
  return origin;
};

export const notifyImpersonationForbidden = (path?: string): void => {
  window.dispatchEvent(new CustomEvent(IMPERSONATION_FORBIDDEN_EVENT, { detail: { path } }));
};
